import { useSession } from '../session/session.jsx';
import { Button } from '../ui/primitives.jsx';

export function SignedOut() {
  const { login } = useSession();
  return (
    <main class="plain auth-screen">
      <div class="auth-screen__stage">
        <header class="auth-screen__brand" aria-label="Loom">
          <span class="auth-screen__mark" aria-hidden="true">◇</span>
          <span>Loom</span>
        </header>

        <section class="auth-card" aria-labelledby="auth-title">
          <p class="auth-card__eyebrow">COMMON NETWORK</p>
          <h1 id="auth-title" class="t-display">사람 인증으로<br />공동 작업을 시작합니다.</h1>
          <p class="auth-card__lead">
            Loom은 대화, Task, AI의 제안을 한 경계 안에서 다시 읽을 수 있게 남깁니다.
            시작은 사람의 확인에서만 열립니다.
          </p>

          <div class="auth-card__rules" aria-label="Loom의 기본 원칙">
            <div>
              <span class="auth-card__rule-no">01</span>
              <p><strong>대화는 원문으로 남습니다.</strong><br />Task가 자동으로 생기지 않습니다.</p>
            </div>
            <div>
              <span class="auth-card__rule-no">02</span>
              <p><strong>AI의 제안은 사람의 수락을 기다립니다.</strong><br />공동 이해는 직접 결정할 때만 바뀝니다.</p>
            </div>
          </div>

          <div class="auth-card__action">
            <Button tone="human" size="lg" onClick={() => login()}>
              Loom으로 로그인
            </Button>
            <p class="t-meta">로그인 뒤, 참여 중인 Space와 사람 Node를 확인합니다.</p>
          </div>
        </section>
      </div>
    </main>
  );
}
